var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "form-group w-full",
    class: _vm.$attrs.class
  }, [_c('ValidationProvider', _vm._b({
    attrs: {
      "name": _vm.name,
      "rules": _vm.rules
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var errors = _ref.errors;
        return [_vm.label ? _c('label', {
          staticClass: "block text-base font-normal mb-1",
          class: _vm.labelClass
        }, [_vm._v(_vm._s(_vm.label)), _vm.isRequired ? _c('b', {
          staticClass: "ml-1 text-red-600 font-bold"
        }, [_vm._v("*")]) : _vm._e()]) : _vm._e(), _c('div', {
          staticClass: "relative input-group"
        }, [_vm.leftIcon ? _c('div', {
          staticClass: "icon-left"
        }, [_c('i', {
          class: _vm.leftIcon
        })]) : _vm._e(), _c('textarea', _vm._b({
          class: ['form-control', _vm.inputClass, _vm.leftIcon ? 'pl-10' : '', _vm.rightIcon ? 'pr-10' : '', _vm.value !== '' ? 'bg-white' : 'bg-gray-100'],
          attrs: {
            "cols": _vm.cols,
            "rows": _vm.rows,
            "autocomplete": "off"
          },
          domProps: {
            "value": _vm.value
          },
          on: {
            "input": _vm.onChange
          }
        }, 'textarea', _vm.$attrs, false)), _vm._v(" "), _vm.rightIcon ? _c('div', {
          staticClass: "icon-right"
        }, [_c('i', {
          class: _vm.rightIcon
        })]) : _vm._e()]), _c('span', {
          staticClass: "text-xs text-red-600"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  }, 'ValidationProvider', _vm.$attrs, false))], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }